import { Form, Modal, ModalProps, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useApplyToSubstitute } from "./queries"
import { useEffect, useState } from "react"
import TextArea from "antd/es/input/TextArea"

interface Props extends ModalProps {
  data?: string
  onClose: () => void
}
const ApplyToSubstituteModal: React.FC<Props> = ({ data: id, ...props }) => {
  const { t } = useTranslation()
  const [comment, setComment] = useState<string | undefined>()
  const { mutate, isLoading } = useApplyToSubstitute(id!, {
    meta: {
      type: "create",
      entity: t("global.application", { count: 1 }),
      context: "female",
      count: 1,
    },
  })

  const onSubmit = () => {
    mutate(
      {
        comment,
      },
      {
        onSettled() {
          props.onClose()
        },
      }
    )
  }

  useEffect(() => {
    !props.open && setComment(undefined)
  }, [props.open])

  return (
    <Modal
      title={t("assignations.apply_for_substitution")}
      onOk={onSubmit}
      okText={t("global.apply")}
      confirmLoading={isLoading}
      onCancel={props.onClose}
      cancelText={t("global.cancel")}
      {...props}
    >
      <Form layout="vertical">
        <Form.Item label={t("labels.comment")}>
          <TextArea
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Form.Item>
        <Typography.Text>
          {t("assignations.apply_for_substitution_confirmation")}
        </Typography.Text>
      </Form>
    </Modal>
  )
}

export default ApplyToSubstituteModal
